/** Subtask and edit action groups for the task list actions hook. */
import { useTaskListSubtaskActions } from '@/features/tasks/hooks/list/use-task-list-subtask-actions';
import { useTaskListEditActions } from '@/features/tasks/hooks/list/use-task-list-edit-actions';

export function useTaskListActionGroups({
  allTasks,
  user,
  updateTask,
  handleAddTask,
  deselectAllTasks,
  onStopEditing,
  editingTaskId,
  selectSingleTask,
  taskListRef,
}) {
  const subtaskActions = useTaskListSubtaskActions({
    allTasks,
    user,
    updateTask,
    handleAddTask,
    deselectAllTasks,
    onStopEditing,
  });

  const editActions = useTaskListEditActions({
    user,
    updateTask,
    editingTaskId,
    onStopEditing,
    selectSingleTask,
    taskListRef,
  });

  return { ...subtaskActions, ...editActions };
}
